/*
 * Invilus Text-Polish
 *
 * Replaces "Mathematical Bold" Unicode characters (used by Amazon-style
 * product copy: 𝘼𝙐𝙎𝙉𝘼𝙃𝙈𝙎𝙇𝙊𝙎, 𝙍𝙤𝙡𝙡𝙩𝙤𝙥, etc.) with regular ASCII
 * letters wrapped in <strong> tags. These Unicode block characters fall
 * back to a system font and break the brand typography (Inter). After
 * cleanup, the same emphasis renders in proper Inter-Bold.
 *
 * Target nodes: product description and accordion content on PDPs.
 */
(function () {
  'use strict';

  // Unicode ranges Amazon-style copy commonly uses. Each entry:
  //   [start, end, asciiBaseUpper, asciiBaseLower]
  // The block contains 26 uppercase letters followed by 26 lowercase.
  var RANGES = [
    [0x1d400, 0x1d433, 0x41, 0x61], // Mathematical Bold
    [0x1d5d4, 0x1d607, 0x41, 0x61], // Mathematical Sans-Serif Bold
    [0x1d63c, 0x1d66f, 0x41, 0x61], // Mathematical Sans-Serif Bold Italic
    [0x1d56c, 0x1d59f, 0x41, 0x61], // Mathematical Bold Fraktur
    [0x1d4d0, 0x1d503, 0x41, 0x61], // Mathematical Bold Script
  ];

  function convertChar(cp) {
    for (var i = 0; i < RANGES.length; i++) {
      var r = RANGES[i];
      if (cp >= r[0] && cp <= r[0] + 25) {
        return String.fromCharCode(r[2] + cp - r[0]);
      }
      if (cp >= r[0] + 26 && cp <= r[1]) {
        return String.fromCharCode(r[3] + cp - r[0] - 26);
      }
    }
    return String.fromCodePoint(cp);
  }

  function isBoldChar(cp) {
    for (var i = 0; i < RANGES.length; i++) {
      if (cp >= RANGES[i][0] && cp <= RANGES[i][1]) return true;
    }
    return false;
  }

  function cleanText(text) {
    var out = '';
    var buf = '';
    var inBold = false;

    // Iterate by code point (handle surrogate pairs correctly).
    var chars = Array.from(text);
    for (var i = 0; i < chars.length; i++) {
      var ch = chars[i];
      var cp = ch.codePointAt(0);
      if (isBoldChar(cp)) {
        if (!inBold) {
          out += escapeHtml(buf);
          buf = '';
          inBold = true;
        }
        buf += convertChar(cp);
      } else {
        if (inBold) {
          out += '<strong>' + escapeHtml(buf) + '</strong>';
          buf = '';
          inBold = false;
        }
        buf += ch;
      }
    }

    if (inBold) {
      out += '<strong>' + escapeHtml(buf) + '</strong>';
    } else {
      out += escapeHtml(buf);
    }

    return out;
  }

  function escapeHtml(s) {
    return s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function cleanNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      var original = node.textContent;
      // Quick check: skip if no bold chars present.
      var hasBold = false;
      var chars = Array.from(original);
      for (var i = 0; i < chars.length; i++) {
        if (isBoldChar(chars[i].codePointAt(0))) {
          hasBold = true;
          break;
        }
      }
      if (!hasBold) return;

      var cleaned = cleanText(original);
      var wrapper = document.createElement('span');
      wrapper.innerHTML = cleaned;
      var parent = node.parentNode;
      while (wrapper.firstChild) {
        parent.insertBefore(wrapper.firstChild, node);
      }
      parent.removeChild(node);
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      // Skip script/style nodes.
      if (node.tagName === 'SCRIPT' || node.tagName === 'STYLE') return;
      var children = Array.from(node.childNodes);
      for (var j = 0; j < children.length; j++) {
        cleanNode(children[j]);
      }
    }
  }

  function init() {
    var targets = document.querySelectorAll(
      '.product__description, .accordion__content, .rte'
    );
    for (var i = 0; i < targets.length; i++) {
      cleanNode(targets[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
